import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { DeleteShipmentContainer, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* deleteShipmentContainerSaga(action: DeleteShipmentContainer) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeDelete, action.payload.shipmentContainerId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(logisticsActionCreators.removeContainer(action.payload.shipmentContainerId));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteShipmentContainer() {
  yield takeEvery(LogisticsActionKeys.DELETE_SHIPMENT_CONTAINER, deleteShipmentContainerSaga);
}

export async function executeDelete(shipmentContainerId: number): Promise<IApiExecuteRespone> {
  return executeApiRequest(() => httpService.delete(`${ApiUrls.shipment()}/Containers/${shipmentContainerId}`), false);
}
